import { drawing } from '@progress/kendo-drawing';
import { Group } from './Group.js';
import { toDrawingRect } from './utils.js';
import '../math/Graph.js';
import { Rect } from '../math/Shapes.js';
import { deepExtend } from '../utils/deep-extend.js';

class Layout extends Group {
    constructor(rect, options) {
        super(options);
        this.drawingElement = new drawing.Layout(toDrawingRect(rect), options);
        this._initSize();
    }
    rect(rect) {
        if (rect) {
            this.drawingElement.rect(toDrawingRect(rect));
        }
        else {
            const drawingRect = this.drawingElement.rect();
            if (drawingRect) {
                return new Rect(drawingRect.origin.x, drawingRect.origin.y, drawingRect.size.width, drawingRect.size.height);
            }
        }
    }
    reflow() {
        this.drawingElement.reflow();
    }
    redraw(options) {
        deepExtend(this.drawingElement.options, options);
        super.redraw.call(this, options);
    }
}

export { Layout };
